import React from "react";
import { Link } from 'react-router-dom';
import './css/NotFound.css';
const NotFound: React.FC = () => {
    return (
        <div className="notfound-container">
            <div className="notfound-face">:(</div>
            <h1>404 - Хуудас олдсонгүй</h1>
            <p>Таны хайж буй хуудас байхгүй байна</p>
            <Link to="/" className="notfound-home">Нүүр хуудас луу буцах</Link>
        </div>
    );
};

export default NotFound;